<app-content-container>
  <div class="flex flex-col items-center">
    <div
      class="max-w-[780px] w-full flex flex-col items-center p-8 md:p-12 rounded-3xl bg-[#161E2E]/60 backdrop-blur-md border border-white/10 hover:border-primary/50 hover:shadow-[0_0_30px_rgba(102,87,236,0.2)] transition-all duration-500"
    >
      <h1 class="section-title font-bold text-center">
        Entre na nossa comunidade
      </h1>

      <p class="section-description text-center mt-8 w-full max-w-[650px]">
        Faça parte da nossa comunidade e fique por dentro dos nossos novos
        cursos, promoções, vídeos, lives e muito mais!
      </p>

      <div class="mt-12 flex justify-center">
        <form class="w-full max-w-[350px]" (submit)="submit($event)">
          <app-fieldset
            label="Email"
            legendClass="text-sm"
            errorTestId="community-form-email-error"
          >
            <input
              type="text"
              class="input"
              placeholder="Digite seu melhor email"
              data-testid="community-form-email"
              [formField]="form.email"
            />
          </app-fieldset>

          <button
            class="btn btn-primary mt-4 block w-fit mx-auto"
            [disabled]="form().invalid() || form().submitting()"
            data-testid="community-form-submit"
          >
            @if (form().submitting()) { Entrando... } @else { Entrar na
            comunidade }
          </button>

          @for (error of form().errors(); track error.message) {
          <p data-testid="community-form-error" class="label text-error">
            {{ error.message }}
          </p>
          }
        </form>
      </div>
    </div>
  </div>
</app-content-container>
